import { render } from "./OnePage.vue?vue&type=template&id=4f9ecbb0&lang=pug"
import script from "./OnePage.vue?vue&type=script&setup=true&lang=js"
export * from "./OnePage.vue?vue&type=script&setup=true&lang=js"

import "./OnePage.vue?vue&type=style&index=0&id=4f9ecbb0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__